import { apiFetch } from "./client";

export interface MaskedKeyStatus {
  configured: boolean;
  masked: string | null;
}

export interface ImageGenSettings {
  provider: "azure_foundry" | "google";
  foundryEndpoint: string;
  foundryDeployment: string;
  foundryApiKey: MaskedKeyStatus;
  googleApiKey: MaskedKeyStatus;
}

export interface SaveImageGenSettingsRequest {
  provider?: "azure_foundry" | "google";
  foundryEndpoint?: string;
  foundryDeployment?: string;
  /** Write-only: only sent when the admin enters a new key. */
  foundryApiKey?: string;
  googleApiKey?: string;
}

export const imageGenApi = {
  get: () => apiFetch<ImageGenSettings>("/admin/image-gen-settings"),
  update: (data: SaveImageGenSettingsRequest) =>
    apiFetch<ImageGenSettings>("/admin/image-gen-settings", {
      method: "PUT",
      body: JSON.stringify(data),
    }),
};
